import BaseService from '@/services/base_service';
import { clearPhone } from '@/services/string';
import Axios from 'axios';

export default class ClinicService extends BaseService {

  async list(params) {
    try {
      return await axios.get('/clinica/', params);
    } catch (e) {
      throw e;
    }
  }
  async get(id) {
    try {
      return await axios.get('/clinica/' + id);
    } catch (e) {
      throw e;
    }
  }
  async create(model) {
    try {
      return await axios.post('clinica/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/clinica/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/clinica/' + id);
    } catch (e) {
      throw e;
    }
  }

  async import(model) {
    try {
      return await axios.post('clinica/upload', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/clinic.js